// import React, { useState, useEffect } from 'react';
// import './ImageSlider.css';
// import { homepageSliderData } from '../../../data/HomepageSlider';
// import ApiService from '../../../services/apiService';

// const ImageSlider = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [sliderData, setSliderData] = useState(homepageSliderData);
//   const [isLoading, setIsLoading] = useState(true);
  
//   // Load slider data from WordPress API with fallback to static data
//   useEffect(() => {
//     const loadSliderData = async () => {
//       try {
//         setIsLoading(true);
//         console.log('🔄 Loading slider images from WordPress API...');
        
//         const response = await ApiService.getSliderImages();
//         console.log('📥 API Response received:', response);
        
//         if (response.data && response.data.length > 0) {
//           // Transform WordPress API response to match our component structure
//           const transformedData = response.data.map((item) => {
//             let imageUrl = null;
            
//             // Check ACF image_upload field first (this is where your images are)
//             if (item.acf?.image_upload?.url) {
//               imageUrl = item.acf.image_upload.url;
//             }
//             // Fallback to featured media if available
//             else if (item.featured_media && item.featured_media !== 0) {
//               // Note: We'd need to make another API call for featured media
//               // but since your data uses ACF image_upload, we'll skip this for now
//               console.log('Featured media found but using ACF image_upload instead');
//             }
            
//             // Only return items that have valid images
//             return imageUrl ? {
//               id: item.id,
//               image: imageUrl,
//               title: item.title.rendered,
//               caption: item.acf?.caption || item.title.rendered,
//               alt: item.acf?.alt_text || item.acf?.image_upload?.alt || item.title.rendered
//             } : null;
//           });
          
//           // Filter out null entries (items without images)
//           const validImages = transformedData.filter(item => item !== null);
          
//           console.log('✅ Using WordPress API slider data:', validImages);
//           console.log('📊 Number of valid images from API:', validImages.length);
          
//           if (validImages.length > 0) {
//             setSliderData(validImages.reverse()); // Show latest images first
//           } else {
//             console.log('⚠️  No valid images found in API response');
//             setSliderData([]);
//           }
//         } else {
//           console.log('⚠️  No slider images from API');
//           setSliderData([]);
//         }
//       } catch (error) {
//         // No fallback - only show fetched images
//         console.error('❌ Error loading slider images from WordPress API:', error);
//         setSliderData([]);
//       } finally {
//         setIsLoading(false);
//         console.log('🏁 Slider loading completed');
//       }
//     };

//     loadSliderData();
//   }, []);
  
//   // Auto-advance slides and pause on hover
//   useEffect(() => {
//     if (isLoading || sliderData.length === 0) return;

//     let interval;
//     const startSlideshow = () => {
//       interval = setInterval(() => {
//         setCurrentSlide((prevSlide) => (prevSlide + 1) % sliderData.length);
//       }, 6000);
//     };
    
//     startSlideshow();
    
//     // Clean up interval on component unmount
//     return () => clearInterval(interval);
//   }, [sliderData.length, isLoading]);
  
//   const goToSlide = (slideIndex) => {
//     setCurrentSlide(slideIndex);
//   };

//   const nextSlide = () => {
//     setCurrentSlide((prevSlide) => (prevSlide + 1) % sliderData.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prevSlide) => (prevSlide - 1 + sliderData.length) % sliderData.length);
//   };

//   const captionStyles = {
//     color: 'white',
//     WebkitTextFillColor: 'white',
//     textFillColor: 'white'
//   };

//   // Show loading state
//   if (isLoading) {
//     return (
//       <div className="slider-container">
//         <div className="slider-loading">
//           <div className="loading-spinner"></div>
//           <p>Loading images...</p>
//         </div>
//       </div>
//     );
//   }

//   // Handle empty slider data
//   if (!sliderData || sliderData.length === 0) {
//     return (
//       <div className="slider-container">
//         <div className="slider-empty">
//           <p>No slider images available</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="slider-container">
//       <div className="slider">
//         {sliderData.map((slide, index) => (
//           <div
//             key={slide.id}
//             className={`slide ${index === currentSlide ? 'active' : ''}`}
//             style={{ transform: `translateX(${100 * (index - currentSlide)}%)` }}
//           >
//             <img 
//               src={slide.image} 
//               alt={slide.alt} 
//               onLoad={(e) => {
//                 console.log('✅ Image loaded successfully:', slide.image);
//               }}
//               onError={(e) => {
//                 console.error('❌ Image failed to load:', {
//                   originalSrc: slide.image,
//                   currentSrc: e.target.src,
//                   alt: slide.alt,
//                   title: slide.title
//                 });
                
//                 // First try: fallback to static slider images based on filename
//                 if (!e.target.src.includes('/sliderImages/')) {
//                   // Try to match the filename from the API URL to a static image
//                   const filename = slide.image.split('/').pop();
//                   const staticImagePath = `/sliderImages/${filename}`;
//                   console.log('🔄 Trying static image fallback:', staticImagePath);
//                   e.target.src = staticImagePath;
//                 } else {
//                   // Second fallback: use admin_block.jpg as default
//                   console.log('🔄 Using final fallback image: /sliderImages/admin_block.jpg');
//                   e.target.src = '/sliderImages/admin_block.jpg';
//                 }
//               }}
//             />
//             <div 
//               className="slide-caption image-slider-caption" 
//               style={captionStyles}
//             >
//               <h2 
//                 className="image-slider-heading" 
//                 style={captionStyles}
//               >
//                 {slide.caption || slide.title}
//               </h2>
//             </div>
//           </div>
//         ))}
//       </div>

//       <button 
//         className="slider-arrow prev" 
//         onClick={prevSlide}
//         aria-label="Previous slide"
//       >
//         &#10094;
//       </button>
//       <button 
//         className="slider-arrow next" 
//         onClick={nextSlide}
//         aria-label="Next slide"
//       >
//         &#10095;
//       </button>
      
//       <div className="slider-dots">
//         {sliderData.map((slide, index) => (
//           <button
//             key={slide.id}
//             className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
//             onClick={() => goToSlide(index)}
//             aria-label={`Go to slide ${index + 1}`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ImageSlider;

import React, { useState, useEffect } from "react";
import "./ImageSlider.css";
import { homepageSliderData } from "../../../data/HomepageSlider";
import ApiService from "../../../services/apiService";

const ImageSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderData, setSliderData] = useState(homepageSliderData || []);
  const [isLoading, setIsLoading] = useState(true);

  // Load images from WordPress API
  useEffect(() => {
    const loadSliderData = async () => {
      try {
        setIsLoading(true);

        const response = await ApiService.getSliderImages();

        const items = Array.isArray(response?.data)
          ? response.data
          : [];

        const validImages = items
          .map((item) => {
            const imageUrl = item.acf?.image_upload?.url;

            if (!imageUrl) return null;

            return {
              id: item.id,
              image: imageUrl,
              title:
                item.title?.rendered || "Rayalaseema University",
              caption:
                item.acf?.caption ||
                item.title?.rendered ||
                "Rayalaseema University",
              alt:
                item.acf?.alt_text ||
                item.acf?.image_upload?.alt ||
                item.title?.rendered ||
                "Rayalaseema University",
            };
          })
          .filter(Boolean)
          .reverse();

        if (validImages.length > 0) {
          setSliderData(validImages);
        } else {
          setSliderData([]);
        }
      } catch (error) {
        console.error("Error loading slider images:", error);
        setSliderData([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadSliderData();
  }, []);

  // Automatically advance slides
  useEffect(() => {
    if (isLoading || sliderData.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((previous) =>
        (previous + 1) % sliderData.length
      );
    }, 6000);

    return () => clearInterval(interval);
  }, [sliderData.length, isLoading]);

  // Keep the selected index valid
  useEffect(() => {
    if (currentSlide >= sliderData.length) {
      setCurrentSlide(0);
    }
  }, [currentSlide, sliderData.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    if (sliderData.length <= 1) return;

    setCurrentSlide(
      (previous) => (previous + 1) % sliderData.length
    );
  };

  const prevSlide = () => {
    if (sliderData.length <= 1) return;

    setCurrentSlide(
      (previous) =>
        (previous - 1 + sliderData.length) % sliderData.length
    );
  };

  // Loading state
  if (isLoading) {
    return (
      <div className="slider-container">
        <div className="slider-loading">
          <div className="loading-spinner"></div>
          <p>Loading images...</p>
        </div>
      </div>
    );
  }

  // Empty state
  if (sliderData.length === 0) {
    return (
      <div className="slider-container">
        <div className="slider-empty">
          <p>No slider images available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="slider-container">
      <div className="slider">
        {sliderData.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${
              index === currentSlide ? "active" : ""
            }`}
            style={{
              transform: `translateX(${
                100 * (index - currentSlide)
              }%)`,
            }}
            aria-hidden={index !== currentSlide}
          >
            <img
              src={slide.image}
              alt={slide.alt}
              loading={index === 0 ? "eager" : "lazy"}
              onError={(event) => {
                console.error(
                  "Failed to load slider image:",
                  slide.image
                );

                // Avoid repeating a failed fallback request
                event.currentTarget.onerror = null;

                const filename = slide.image
                  .split("/")
                  .pop()
                  .split("?")[0];

                const fallbackUrl =
                  `/sliderImages/${filename}`;

                if (
                  !slide.image.includes("/sliderImages/") &&
                  filename
                ) {
                  event.currentTarget.src = fallbackUrl;
                } else {
                  event.currentTarget.src =
                    "/sliderImages/admin_block.jpg";
                }
              }}
            />

            <div className="slide-caption image-slider-caption">
              <h2 className="image-slider-heading">
                {slide.caption || slide.title}
              </h2>
            </div>
          </div>
        ))}
      </div>

      {sliderData.length > 1 && (
        <>
          <button
            type="button"
            className="slider-arrow prev"
            onClick={prevSlide}
            aria-label="Previous slide"
          >
            &#10094;
          </button>

          <button
            type="button"
            className="slider-arrow next"
            onClick={nextSlide}
            aria-label="Next slide"
          >
            &#10095;
          </button>

          <div className="slider-dots">
            {sliderData.map((slide, index) => (
              <button
                key={slide.id}
                type="button"
                className={`slider-dot ${
                  index === currentSlide ? "active" : ""
                }`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
                aria-current={
                  index === currentSlide ? "true" : undefined
                }
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ImageSlider;
